export function TabPanel({ value, index, children }: any) {
  if (value === index) {
    return children;
  }
  return null;
}
